<template>
    <div class="chat" ref="container">

        <div class="chat-app" ref="chatApp" v-if="dialogBox">
            <!-- 顶部 -->
            <div class="chat-header win_head" :style="{...themeBg}">
                <div class="chat-title">
                    <div class="title-logo-box">
                        <img class="title-logo" :src="topTitleLogo" alt="logo">
                    </div>

                    {{topTitle}}
                </div>

                <span class="close-btn" @click="onClose">×</span>
            </div>

            <!-- 内容区 -->
            <div class="chat-box" ref="chatBox">
                <div class="chat-box-content" ref="chatBoxContent">
                    <div v-for="(item,i) in list" :key="i">

                        <div class="chat-row" v-if="item.type === 'customer'">
                            <div class="chat-logo customer-logo" :style="{...whiteBg}">
                                <img class="chatAvatar" :src="customerLogo" alt="logo">
                            </div>

                            <div class="chat-msg-content">
                                <div class="chat-username">{{customerTitle}} {{shortTime(item.time)}}</div>
                                <!--  chat-content标签、item.content 和span 标签 请保持在同一行 -->
                                <div class="chat-content">{{item.content}} <span class="enter-cursor"
                                        v-if="item.isInputting"></span>
                                </div>

                            </div>
                        </div>

                        <div class="chat-row chat-row-me" v-if="item.type === 'user'">
                            <div class="chat-msg-content">
                                <div class="chat-username">{{userName}} {{shortTime(item.time)}}</div>
                                <div class="chat-content">{{item.content}}</div>
                            </div>

                            <div class="chat-logo user-logo">
                                <img class="chatAvatar-user" src="./assset/img/userlogo.png" alt="userlogo">
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- 输入框 -->
            <div class="chat-bottom">
                <div>
                    <textarea ref="myTextarea" v-model="userInput" @keydown.enter="keyDown" class="textarea" rows="4"
                        placeholder="很高兴为您服务，请描述您的问题"></textarea>
                </div>

                <div class="send">
                    <button :class="[ isCustomerInputting ? 'no-send' : '' , 'send-btn' ]" :style="{...themeBg}"
                        @click="sendMsg">发送
                    </button>
                </div>
            </div>

        </div>

        <!-- 右侧图标 -->
        <div class="znkf" v-show="!dialogBox && !isIE" @click="onOpen">
            <img src="./assset/img/znkf.gif" alt="">
        </div>

        <!-- 模态框 -->
        <div class="my-model" v-if="myModel">
            <div class="my-model-content">
                <div class="hanlder">
                    提示
                </div>
                <div class="content">
                    <div class="left">
                        <img src="./assset/img/warning.png" alt="">
                    </div>
                    <div class="right">{{customerTitle}} 正在回复中，现在关闭系统会自动结束对话。 </div>
                </div>
                <div class="footer">
                    <button @click="myModel = false">取消</button>
                    <button class="footer-btn" :style="{...themeBg , border: `1px solid ${themeColor}`}"
                        @click="closeHandle">
                        确定
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
import CHAT from './mixins/chat';

export default {
    mixins: [CHAT],
    name: '',
    props: {
        // 主题色
        themeColor: {
            type: String,
            default: '#700a7a',
        },

        // 顶部 客服名称
        topTitle: {
            type: String,
            default: '小惠',
        },
        topTitleLogo: {
            type: String,
            default: 'http://www.zhbykj.com/logos/single/logo.png',
        },

        customerTitle: {
            type: String,
            default: '唯一客服系统',
        },
        customerLogo: {
            type: String,
            default: 'http://www.zhbykj.com/logos/single/logo-l.png',
        },
        userName: {
            type: String,
            default: '我',
        },
        //问候语
        greetings: {
            type: String,
            default: '您好，我是智能客服机器人小惠，请问有什么可以帮您？(请先选您要咨询的业务模块哦）',
        },

        // 请求地址
        postUrl: {
            type: String,
            default: 'http://chat.smartprocure.cn/chat/chat',
        },
        // 请求传递的其他参数
        otherParam: {
            type: Object,
            default: () => { return {}; }
        },
        //  返回流数据 第一个的属性名 关键字
        receiveKeywords: {
            type: String,
            default: 'requestId',
        },
    },

    data () {
        return {
            isIE: true, //是否是ie 浏览器
            dialogBox: false,
            userInput: '',
            inputCon: '',    // 接收 刚输入的 userInput

            shouldEndStream: false,     // 循环的时候 是否需要提前结束流
            myModel: false, //模态框

            // 聊天记录
            list: [
                // {
                //     type: 'customer',
                //     time: 'Tue Mar 19 2024 10:19:39 GMT+0800 (中国标准时间)',
                //     content: '您好，我是智能客服机器人小惠，请问有什么可以帮您？(请先选您要咨询的业务模块哦）',
                //     isInputting: false, //是否正在输入
                // },
                // {
                //     type: 'user',
                //     time: 'Tue Mar 19 2024 10:19:39 GMT+0800 (中国标准时间)',
                //     content: '如何注册账号？',
                //     isInputting: false, //是否正在输入
                // },
            ],

            themeBg: { backgroundColor: this.themeColor },
            whiteBg: { backgroundColor: '#fff' },

        };
    },


    computed: {
        // 判断 客服 是否正在 接收数据
        isCustomerInputting () {
            if (!!this.list
                && this.list.length > 0
                && this.list[this.list.length - 1].type === 'customer'
                && this.list[this.list.length - 1].isInputting) {
                return true;
            } else {
                return false;
            }
        },
    },

    watch: {},

    mounted () {
        this.isIEFun();
    },

    methods: {

        onClose () {
            if (this.isCustomerInputting) {
                this.myModel = true;
            } else {
                this.closeHandle();
            }
        },
        closeHandle () {
            var that = this;
            that.shouldEndStream = true;

            //判断是否流结束了
            if (that.isCustomerInputting) {
                setTimeout(() => {
                    that.closeHandle();
                }, 300);
                return;
            }

            that.dialogBox = false;
            that.myModel = false;
            that.onReset();
        },


        onOpen () {
            if (this.isIE) {
                return;
            }

            this.onInit();
            this.dialogBox = true;
            this.shouldEndStream = false;

            this.$nextTick(() => {
                this.$refs.myTextarea?.focus();
                const dragDirective = this.directives.drag;
                dragDirective.bind(this.$refs.chatApp, this.$attrs[dragDirective.expression], this);
            });
        },

        // 重置数据
        onReset () {
            this.list = [];
        },
        // 初始化
        onInit () {
            this.list = [
                {
                    type: 'customer',
                    time: new Date(),
                    content: this.greetings,
                },
            ];
            this.userInput = '';
        },

        // 发送请求
        sendMsg () {
            // 判断输入非空
            if (this.userInput.trim() === '') {
                return;
            }
            if (this.isCustomerInputting) {
                return;
            }

            let userObj = {
                type: "user",
                time: new Date(),
                content: this.userInput,
                isInputting: false, //是否正在输入
            };

            this.inputCon = this.userInput;
            this.userInput = '';
            this.list.push(userObj);
            this.keepBootom();

            this.pushCustomerDialogue('', true);

            this.createUrl();
        },

        //创建请求
        async createUrl () {
            var that = this;
            let curRequestController = new AbortController();
            let response = null;  // 请求地址

            let data = { content: that.inputCon, ...that.otherParam };

            try {
                response = await fetch(that.postUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                    },
                    signal: curRequestController.signal,
                    body: JSON.stringify(data),
                });

                // 检查响应状态
                if (!response.ok) {
                    that.pushCustomerDialogue(`HTTP error! status: ${response.status}`);

                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                //  创建可读流 循环读取流中的数据
                await this.onopen(response);


            } catch (err) {
                that.pushCustomerDialogue(err);

                curRequestController.abort();
                that.closeCustomerIsInputting();

                return;
            }
        },

        // 读取 返回流数据
        async onopen (response) {
            var that = this;
            var lastData = '';

            if (response?.status !== 200) {
                throw response;
            }

            // 检查响应是否成功
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);  // 错误提示
            }

            // 获取响应的ReadableStream body
            const readableStreamBody = response.body;
            // 检查body是否是ReadableStream
            if (!readableStreamBody || !(readableStreamBody instanceof ReadableStream)) {
                throw new Error('Response body is not a ReadableStream');
            }

            // 使用ReadableStreamDefaultReader来读取数据
            const reader = readableStreamBody.getReader();


            // 循环读取流中的数据
            while (true) {
                const { value, done } = await reader.read();
                let listLastObj = that.list[that.list.length - 1];

                if (done) {
                    // 流已结束
                    // 最后客服 关闭 恢复状态
                    that.closeCustomerIsInputting();

                    break;  //起作用
                }

                //是否 主动结束流
                if (that.shouldEndStream) {
                    that.closeCustomerIsInputting();
                    reader.releaseLock();
                    readableStreamBody.cancel();

                    break;  //起作用
                }

                // 使用TextDecoder进行解码
                const textDecoder = new TextDecoder('utf-8');
                const string = textDecoder.decode(value);

                //  空格 、 返回多条数据
                let newStr = string.replace(/data:/g, '');


                // 判断一次接收 是否多条数据 try catch

                // 使用正则表达式匹配"requestId"
                const regGetNum = new RegExp(`${that.receiveKeywords}`, 'g');

                // 找到所有匹配的项
                const matches = newStr.match(regGetNum);
                // 出现的次数
                const keySum = matches ? matches.length : 0;

                if (keySum < 2) {
                    //单条
                    contentHandle(newStr);
                    lastData = newStr;

                } else {
                    // 多条
                    // 正则表达式匹配以 "{"requestId" 开始，到下一个 "{"requestId" 之前的所有内容
                    const regGetArr = new RegExp(`\\{"${this.receiveKeywords}".*?(?=\\{"${this.receiveKeywords}"|$)`, 'gs');
                    // 使用 match 方法找到所有匹配的子字符串
                    const keyArr = newStr.match(regGetArr);
                    // 数组循环
                    keyArr.forEach((val) => {
                        contentHandle(val);
                        lastData = val;
                    });
                }


                function contentHandle (val) {

                    let noEmpty = val.trim();

                    if (!!noEmpty && noEmpty.length > 0) {
                        try {
                            let resText = JSON.parse(val).data.content;

                            // 对话列表list  最后是 customer 正在输入的，继续输入
                            if (that.isCustomerInputting) {
                                that.$set(that.list[that.list.length - 1], 'content', resText);
                            }

                            // 最后是  输入完成，push 一个
                            if (!listLastObj.isInputting) {
                                that.list.push({
                                    type: 'customer',
                                    time: new Date(),
                                    content: resText,
                                    isInputting: true, //是否正在输入
                                });
                            }

                            that.keepBootom();
                        } catch (err) {
                            console.log('读取数据错误 err', err);
                        }
                    }
                }
            }

            //  等待循环结束，判断最后一次，返回是否正确
            async function errMsg (val) {
                if (JSON.parse(val) && !JSON.parse(val).success) {
                    that.pushCustomerDialogue(JSON.parse(val).errorMsg);
                    that.closeCustomerIsInputting();

                    return;
                }
            };

            errMsg(lastData);

            // 关闭可读流
            reader.releaseLock();
            // 确保在读取完成后取消读取操作
            readableStreamBody.cancel();
        },

        // 结束 关闭 客服输入状态
        closeCustomerIsInputting () {
            if (this.isCustomerInputting) {
                this.$set(this.list[this.list.length - 1], 'isInputting', false);
            }
        },

        // 增加 客服回复 （错误提示）
        pushCustomerDialogue (val, isInputting = false) {
            this.closeCustomerIsInputting();

            //如果最后一个消息是空，删除最后一条
            if (
                this.list.length > 0
                && this.list[this.list.length - 1].type === 'customer'
                && !this.list[this.list.length - 1].content
            ) {
                this.list.pop();
            }

            this.list.push({
                type: 'customer',
                time: new Date(),
                content: val,
                isInputting: isInputting,
            });

            this.keepBootom();
        },

    },
}
</script>

<style lang="scss" scoped>
$chatAppWidth: 840px;
$chatAppHeight: 720px;

.chat {
    width: calc(100%);
    height: calc(100%);

    .chat-app {
        width: $chatAppWidth;
        height: $chatAppHeight;
        border: 1px solid #cecfd3;
        box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.3);
        background-color: #fff;
        border-radius: 5px;

        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: fixed;
        top: calc(50% - $chatAppHeight/2);
        left: calc(50% - $chatAppWidth/2);
        z-index: 9999 !important;

        .chat-header {
            height: 50px;
            width: 100%;
            box-sizing: border-box;
            padding: 10px 15px;

            display: flex;
            justify-content: space-between;
            align-items: center;
            // 禁止文字被选中
            user-select: none;
            cursor: move;

            .chat-title {
                display: flex;
                align-items: center;
                font-size: 18px;
                color: #fff;
                .title-logo-box {
                    width: 32px;
                    height: 32px;
                    margin-right: 10px;
                    border-radius: 50%;
                    background-color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .title-logo {
                    width: 22px;
                    height: 19px;
                }
            }

            .close-btn {
                display: inline-block;
                width: 34px;
                height: 34px;
                line-height: 34px;
                text-align: center;
                font-size: 34px;
                color: #fff;
                cursor: pointer;
            }
        }

        .chat-box {
            flex: 1;
            padding: 0 5px;
            max-height: 500px;
            overflow: auto;

            .chat-row {
                display: flex;
                align-items: flex-start;
                margin: 15px 0px;

                .chat-logo {
                    width: 40px;
                    height: 40px;
                    background-color: #e9ecf3;
                    border: 1px solid #e9ecf3;
                    border-radius: 50%;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: 28px 15px 0;
                }

                .chatAvatar {
                    width: 22px;
                    height: 19px;
                    flex-shrink: 0;
                }
                .chatAvatar-user {
                    width: 30px;
                    height: 30px;
                    color: #fff;
                    text-align: center;
                }
            }

            .chat-username {
                font-size: 13px;
                white-space: nowrap;
                color: #999;
                margin-bottom: 10px;
            }
            .chat-content {
                line-height: 21px;
                max-width: 460px;
                font-size: 14px;
                padding: 10px;
                background-color: #f5f5f5;
                border-radius: 5px;
                box-shadow: 0 5px 30px rgb(50 50 93 / 8%), 0 1px 3px rgb(0 0 0 / 5%);
                word-break: break-all;
                position: relative;
                white-space: pre-line;

                &::before {
                    content: '';
                    position: absolute;
                    top: 10px;
                    left: -7px;
                    border-width: 10px 10px 10px 0;
                    border-style: solid;
                    border-color: transparent #f5f5f5 transparent transparent;
                }

                @keyframes blink {
                    0% {
                        opacity: 0;
                    }
                    100% {
                        opacity: 1;
                    }
                }

                .enter-cursor::after {
                    content: '|';
                    margin-left: 2px;
                    height: 100%;
                    color: #000;
                    animation: blink 1s ease-in 0s infinite;
                }
            }

            .chat-row-me {
                justify-content: flex-end;

                .chat-username {
                    text-align: right;
                    font-size: 13px;
                    white-space: nowrap;
                    color: #999;
                    margin-bottom: 10px;
                }

                .chat-content {
                    border-radius: 5px;
                    &::before {
                        display: none;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        top: 10px;
                        right: -7px;
                        border-width: 10px 0 10px 10px;
                        border-style: solid;
                        border-color: transparent transparent transparent #f5f5f5;
                    }
                }
            }
        }

        .chat-bottom {
            background: #fff;
            border-top: 1px solid #ebebeb;
            padding: 12px 14px;
            box-sizing: border-box;

            textarea {
                width: 100%;
                height: 100px;
                border: none;
                outline: none; /* 移除点击时的边框 */
                padding: 0;
                margin: 0;
                resize: none;
                overflow-y: auto;
                font-size: 14px;
                line-height: 21px;
            }

            ::v-deep .el-textarea__inner {
                border: none;
                padding: 0;
            }

            .send {
                float: right;

                .send-btn {
                    width: 78px;
                    height: 36px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 16px;
                    color: #fff;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    &:hover {
                        opacity: 0.85;
                    }
                }

                .no-send {
                    cursor: not-allowed;
                }
            }
        }
    }

    .znkf {
        width: 198px;
        height: 198px;
        position: fixed;
        top: 65%;
        right: 10px;
        cursor: pointer;
        z-index: 999 !important;
    }

    .my-model {
        width: calc(100%);
        height: calc(100%);
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 99999;
        box-sizing: content-box;

        .my-model-content {
            width: 400px;
            height: 146px;
            border-radius: 5px;
            padding: 15px;
            background-color: #fff;
            position: fixed;
            top: calc(50% - (146px / 2));
            left: calc(50% - (400px / 2));
            box-sizing: content-box;

            .hanlder {
                width: 100%;
                height: 44px;
                font-size: 18px;
            }
            .content {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 20px;
                .left {
                    img {
                        width: 26px;
                        height: 26px;
                        margin-right: 15px;
                    }
                }
                .left {
                    flex: 1;
                }
            }

            .footer {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                button {
                    padding: 7px 14px;
                    font-size: 12px;
                    border-radius: 3px;
                    margin-left: 10px;
                    border: 1px solid #cecfd3;
                    background-color: #fff;
                    cursor: pointer;
                }
                .footer-btn {
                    color: #fff;
                    &:hover {
                        opacity: 0.85;
                    }
                }
            }
        }
    }
}
</style>



